import { AxiosRequestConfig } from 'axios'
import { onAccessTokenRefreshed } from '@/plugins/axios'
import { sanitizeHtml, purifyHtml } from '@/helpers/html'
import { lexonHttp } from '@/plugins/axios/lexonHttp'

const defaultConfig = { headers: { 'Content-Type': 'application/json' } }
export class MainService {
  constructor() {}

  getData(url: string, config: AxiosRequestConfig = {}) {
    return lexonHttp.get(url, config)
  }

  postData(url: string, data: object | null = null, sanitizeAll: boolean = true, config = {}) {
    if (data) {
      const params = new URLSearchParams()
      const stringData = JSON.stringify(data)
      const sanitizeData = sanitizeAll ? sanitizeHtml(stringData) : purifyHtml(stringData)
      params.append('json', sanitizeData)
      return lexonHttp.post(url, params, config)
    } else {
      return lexonHttp.post(url)
    }
  }

  postFormData(url: string, formData: FormData) {
    return lexonHttp.post(url, formData)
  }

  postBody(url: string, data: object | null = null, config: AxiosRequestConfig = {}) {
    if (data) {
      return lexonHttp.post(url, data, config)
    } else {
      return lexonHttp.post(url)
    }
  }

  postFormDataWithTimeout(url: string, formData: FormData, timeoutMs: number = 120000) {
    return lexonHttp.post(url, formData, {
      timeout: timeoutMs
    })
  }

  putData(url: string, data: object, config: AxiosRequestConfig = defaultConfig) {
    return lexonHttp.put(url, data, config)
  }

  putJsonData(url: string, data: object | null = null, sanitizeAll: boolean = true) {
    if (data) {
      const params = new URLSearchParams()
      const stringData = JSON.stringify(data)
      const sanitizeData = sanitizeAll ? sanitizeHtml(stringData) : purifyHtml(stringData)
      params.append('json', sanitizeData)
      return this.putFormData(url, params)
    } else {
      return this.putFormData(url, null)
    }
  }

  putFormData(url: string, formData: FormData | null) {
    return lexonHttp.post(url, formData, {headers:{'X-HTTP-Method-Override': 'PUT'}})
  }

  deleteData(url: string) {
    return lexonHttp.delete(url)
  }

  refreshAccessToken(accessToken: string) {
    onAccessTokenRefreshed(accessToken)
    return this
  }
}
